export const LIST_GROUPING_STORAGE_KEY = "unibox_list_grouping";

export function readListGrouping() {
  try {
    const stored = localStorage.getItem(LIST_GROUPING_STORAGE_KEY);
    if (stored === "conversation" || stored === "account") return stored;
    return "account";
  } catch {
    return "account";
  }
}

export function normalizeEmail(value) {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";

  const bracketMatch = raw.match(/<([^>]+)>/);
  if (bracketMatch?.[1]) return bracketMatch[1].trim();

  const firstItem = raw.split(",")[0]?.trim() || "";
  const emailMatch = firstItem.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i);
  return (emailMatch?.[0] || firstItem).toLowerCase();
}

export function getEmailContact(email) {
  const account = normalizeEmail(email?.accountEmail);
  const from = normalizeEmail(email?.from);
  const to = normalizeEmail(email?.to_email);
  const direction = email?.direction || (from === account ? "sent" : "received");
  return direction === "sent" ? to : from;
}

export function parseThreadKey(threadKey) {
  const str = String(threadKey || "");
  const parts = str.split("::");

  if (parts.length >= 3) {
    if (parts[1] === "c") {
      return {
        mode: "account",
        account: parts[0],
        contact: parts.slice(2).join("::"),
        threadId: null,
      };
    }
    if (parts[1] === "t") {
      return {
        mode: "conversation",
        account: parts[0],
        contact: null,
        threadId: parts.slice(2).join("::"),
      };
    }
  }

  const idx = str.indexOf("::");
  if (idx === -1) {
    return { mode: "account", account: null, contact: str, threadId: null };
  }

  return {
    mode: "account",
    account: str.slice(0, idx),
    contact: str.slice(idx + 2),
    threadId: null,
  };
}

export function buildGroupedThreads(rawThreads, listGrouping = "account") {
  const result = {};

  Object.values(rawThreads || {}).forEach((emails) => {
    (emails || []).forEach((email) => {
      const account = normalizeEmail(email.accountEmail);
      if (!account) return;

      const contact = getEmailContact(email);
      if (!contact) return;

      let key;
      if (listGrouping === "conversation") {
        const threadId = String(email.threadId || email.gmailId || "").trim();
        if (!threadId) return;
        key = `${account}::t::${threadId}`;
      } else {
        key = `${account}::c::${contact}`;
      }

      if (!result[key]) result[key] = [];
      result[key].push(email);
    });
  });

  return result;
}
